<footer class="footer">
    <div class="footer-content">
        <div class="footer-brand">
            <b class="footer-logo">Jar.games</b>
            <div class="footer-credit">
                <span aria-label="Made with love by" aria-hidden="false">
                  Made with <span aria-hidden="true">💜</span> by
                </span>
                <button mat-button tabindex="0" class="credit-button" [matMenuTriggerFor]="creditMenu">
                    <div style="display: flex; align-items: center; gap: 0.5rem;">
                        <app-avatar class="credit-avatar" src="/img/jay.png"></app-avatar>
                        Jay
                    </div>
                </button>
                <mat-menu #creditMenu="matMenu">
                    <button mat-menu-item (click)="openLink('https://discord.com/users/482585303228481556')">
                        <mat-icon>discord</mat-icon>
                        <span>Discord</span>
                    </button>
                    <button mat-menu-item routerLink="/credits">
                        <mat-icon>info</mat-icon>
                        <span>About Me</span>
                    </button>
                </mat-menu>
            </div>
        </div>

        <div class="footer-sitemap">
            
            <div class="sitemap-section">
                <h3 class="section-title">Community</h3>
                <ul class="section-links">
                    <li><a href="https://discord.gg/cult-of-jar" target="_blank" rel="noopener noreferrer">Discord</a></li>
                    <li><a routerLink="/gamenight">Game Night</a></li>
                    <li><a routerLink="/events">Events</a></li>
                    <li><a routerLink="/help">Help</a></li>
                </ul>
            </div>

            <div class="sitemap-section">
                <h3 class="section-title">Account</h3>
                <ul class="section-links">
                    <li><a routerLink="/account">Account Settings</a></li>
                    <li><a routerLink="/patreon">Patreon Perks</a></li>
                    <li><a routerLink="/login">Login</a></li>
                </ul>
            </div>

            <div class="sitemap-section">
                <h3 class="section-title">About</h3>
                <ul class="section-links">
                    <li><a routerLink="/help">Help & FAQ</a></li>
                    <li><a routerLink="/credits">Credits</a></li>
                    <li><a routerLink="/privacy">Privacy Policy</a></li>
                    
                </ul>
            </div>

            
        </div>
    </div>
    <div class="footer-version">

        @if (bugReportService.hasErrors()) {
            <button mat-icon-button (click)="submitBugReport()" matTooltip="Submit error log to support">
                <mat-icon>bug_report</mat-icon>
            </button>
        }
        <app-version></app-version>
    </div>
</footer>